import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as serv from '../../services/index'
import * as filters from '../../filters/index'

//constants
import { Constants }         from '../../constants/Constants';

import {BlockComponent} from '../../components/Controls/Block.component';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';

@Component({
  selector: 'my-requestaction-grid',
  templateUrl: './RequestActionGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => RequestActionGridComponent)}]
})
export class RequestActionGridComponent extends BaseGridComponent {
    lineItems: ent.RequestAction[] = [];

    cols: any[];
    requestID?: number;
    startDate?: Date;
    endDate?: Date;
    @Input() showRequestDetails: boolean = false;
    @Input() showSearch: boolean = false;

    @ViewChild(BlockComponent) blockComponent: BlockComponent;


    constructor(private authenticationService: serv.AuthenticationService, private requestService: serv.RequestService, private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.loadColumns();
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'RequestID', header: 'Request ID' },
            { field: 'Request.Employee.FullName', header: 'Submitted By' },
            { field: 'Request.RequestType.Name', header: 'Request Type' },
            { field: 'Action.Name', header: 'Action' },
            { field: 'ActionDate', header: 'Full Date' },
            { field: 'ActionDateDate', header: 'Date' },
            { field: 'ActionDateTime', header: 'Time' },
            { field: 'Notes', header: 'Notes' }
        ];

    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        var filter: filters.RequestActionFilter = 
        {
            RequestID: this.requestID,
            DateStart: this.startDate,
            DateEnd: this.endDate,
            Take: 1000
        };
        
        this.requestService.getRequestActions(filter).subscribe(x=>{
            this.lineItems = x;
            this.blockComponent.blocked = false;
        });
    }
    
}